export default __webpack_public_path__ + "static/media/leap.c5da36ac.svg";